<template>
  <div class="popup-wrapper" @click.self="close">
    <div class="popup-container md center">
      <div class="button close">
        <span role="button" class="btn" @click="close">
          <FontawesomeIcon :icon="['fal','times']" size="lg" class="icn" />
        </span>
      </div>
      <div class="popup">
        <div class="popup-title">
          <span class="hdg02">マイリンクの配置</span>
        </div>
        <div class="popup-content">
          <div class="button">
            <span @click="group1.moveMyLinkToTop" role="button" class="btn">最上位に移動</span>
          </div>
          <div class="button mt12">
            <span @click="group1.moveMyLinkUpOne" role="button" class="btn">一つ上に移動</span>
          </div>
          <div class="button mt12">
            <span @click="group1.moveMyLinkDownOne" role="button" class="btn">一つ下に移動</span>
          </div>
          <div class="button mt12">
            <span @click="group1.moveMyLinkToBottom" role="button" class="btn">最下位に移動</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent, reactive, ref, computed, onMounted } from '@vue/composition-api'

import * as logicMyLinkChangePosition from '@/logic/dashboard/MyLinkChangePosition'

export default defineComponent({
  props: {
    myLinkParams: {
      type: Object,
      required: true
    }
  },
  setup (props, context) {

    onMounted(() => {
      // 初期表示
      group1.init()
    })

    const group1 = logicMyLinkChangePosition.getGroup(props, context)

    const close = () => {
      context.emit('closeMyLinkChangePosition')
    }

    return {
      group1,
      close
    }
  }
})
</script>

<style lang="scss" scoped>
  .popup-content .button {
    width: 267px;
    margin-right: auto;
    margin-left: auto;
  }
</style>
